import clsx from 'clsx';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Typography } from '../typography';
import { ReactElement } from 'react';

interface Information {
	title: string;
	content: string | ReactElement;
}

interface Props {
	information: Information[];
}

export const Accordion: React.FC<Props> = ({ information }) => {
	return (
		<div className="w-full">
			<div className="mx-auto w-full">
				{information?.map(({ title, content }, index) => (
					<Disclosure key={index}>
						{({ open }) => (
							<>
								<Disclosure.Button
									className={clsx(
										'flex w-full justify-between text-left focus:outline-none mt-6',
										{
											'border-b border-[#0D061633] pb-6': !open,
										}
									)}
								>
									<Typography type="bold-22">{title}</Typography>
									<div>
										<ChevronDownIcon
											className={`${
												open ? 'rotate-180 transform' : ''
											} h-6 w-6 text-black opacity-60`}
										/>
									</div>
								</Disclosure.Button>
								<Disclosure.Panel
									className={clsx('pb-6 pt-4 text-sm text-gray-500 border-b ', {
										'border-b border-[#0D061633]': open,
									})}
								>
									<Typography type="regular-16" className="opacity-60">
										{content}
									</Typography>
								</Disclosure.Panel>
							</>
						)}
					</Disclosure>
				))}
			</div>
		</div>
	);
};
